function createCollection(items) {
  const grouped = /* @__PURE__ */ new Map();
  const keyMap = /* @__PURE__ */ new Map();
  if (!items.some((o) => o.group)) {
    return {
      items: items.map((item, index) => {
        keyMap.set(index, { ...item, key: index });
        return keyMap.get(index);
      }),
      index: keyMap
    };
  }
  items.forEach((item) => {
    const { group } = item;
    const values = grouped.get(group) || [];
    values.push({ ...item });
    grouped.set(group, values);
  });
  let i = 0;
  [...grouped].forEach(([, group]) => {
    group.forEach((item) => {
      keyMap.set(i, item);
      Object.assign(item, { key: i });
      i++;
    });
  });
  return { items: [...grouped], index: keyMap };
}
export {
  createCollection
};
//# sourceMappingURL=Collection.es.js.map
